type LearningFacetsLocale = typeof import('../en/learningFacets').default

const learningFacets = {
	criticalConcepts: {
		label: 'Conceptos críticos',
		description: 'Resalta y explica los conceptos más importantes',
	},
	practicalExamples: {
		label: 'Ejemplos prácticos',
		description: 'Ejemplos del mundo real que ilustran el concepto',
	},
	commonMisconceptions: {
		label: 'Malentendidos comunes',
		description: 'Errores comunes y cómo evitarlos',
	},
	realWorldApplications: {
		label: 'Aplicaciones en el mundo real',
		description: 'Cómo se aplica este concepto en la práctica',
	},
	keyTakeaways: {
		label: 'Ideas clave',
		description: 'Puntos esenciales para recordar',
	},
	historicalContext: {
		label: 'Contexto histórico',
		description: 'Cómo se desarrolló este concepto a lo largo del tiempo',
	},
	futureImplications: {
		label: 'Implicaciones futuras',
		description: 'Tendencias emergentes y desarrollos futuros',
	},
	relatedConcepts: {
		label: 'Conceptos relacionados',
		description: 'Ideas conectadas y cómo se relacionan',
	},
	expertInsights: {
		label: 'Perspectivas de expertos',
		description: 'Perspectivas avanzadas de expertos',
	},
	practiceExercises: {
		label: 'Ejercicios prácticos',
		description: 'Ejercicios para aplicar lo aprendido',
	},
	selfAssessment: {
		label: 'Autoevaluación',
		description: 'Preguntas para poner a prueba tu comprensión',
	},
	actionPlan: {
		label: 'Plan de acción',
		description: 'Pasos prácticos para aplicar este conocimiento',
	},
	caseStudy: {
		label: 'Caso de estudio',
		description: 'Análisis en profundidad de un ejemplo real',
	},
	toolsAndResources: {
		label: 'Herramientas y recursos',
		description: 'Herramientas recomendadas y lecturas adicionales',
	},
	bestPractices: {
		label: 'Buenas prácticas',
		description: 'Enfoques y recomendaciones probadas',
	},
	troubleshooting: {
		label: 'Solución de problemas',
		description: 'Problemas comunes y soluciones',
	},
} satisfies LearningFacetsLocale

export default learningFacets
